import type { BrandConfig } from '../brand.types'

const domain = 'https://skufvpn.com'

/** skufvpn.com — основной сайт, терминология «VPN». */
export const skufvpn: BrandConfig = {
	id: 'skufvpn',
	name: 'SKUF VPN',
	domain,
	baseUrl: 'https://backend.skufvpn.com',
	supportEmail: 'support@skufvpn.ru',
	social: {
		telegram: 'https://t.me/skufvpn',
		telegramSupportBot: 'https://t.me/skufhelp_bot',
		instagram: 'https://www.instagram.com/skufvpn',
	},
	analytics: {
		metrikaId: 103316589,
		ecommerceGoalId: 452853084,
	},
	assets: {
		logo: '/logo.svg',
		metaIcon: `${domain}/metaicon.svg`,
		favicon: `${domain}/favicon.ico`,
		// Док «Инструкция по подключению (skufvpn.com)»
		instructionsDocUrl:
			'https://docs.google.com/document/d/1SovlI7cHckrNZ_mZl-ZhZBE_N3ozOpNaSR9fdYh8Emk/edit?tab=t.0',
		appInstructions: {
			ios: {
				happ: 'https://docs.google.com/document/d/197Jks3_JqQb9gd8M3LpeVKrTtwuN1yAFZGQrKMZr7_Q/edit?tab=t.0#heading=h.7w3ojn5sv251',
				streisand:
					'https://docs.google.com/document/d/1AKEmatQe6K5l593E6LSpFXsYte8Lc7bS-Bs3FsB1WNk/edit?tab=t.0',
				v2box:
					'https://docs.google.com/document/d/1A8fzBn9eeK0w0wEtM4HdMV5JI7hBDSCFO8OyeI3LhIA/edit?tab=t.0',
			},
			android: {
				happ: 'https://docs.google.com/document/d/1zpILQAYM9vcGJUHIToNcqIbohQD6ijl0DLnKMT-WVxU/edit?tab=t.0#heading=h.7w3ojn5sv251',
				hiddify:
					'https://docs.google.com/document/d/1C0pkfhS_MJvdYOCLEvTo2H6Z01VJJM-2R3VhNnNqE8Q/edit?tab=t.0#heading=h.7w3ojn5sv251',
			},
			macos: {
				happ: 'https://docs.google.com/document/d/1F2oyqg0Bi2m8B-WHXS8pVqf17J1L5hEWkKzF01OvuFw/edit?tab=t.0#heading=h.7w3ojn5sv251',
				v2box:
					'https://docs.google.com/document/d/1d20hsm1-4jGbmgkFAZT01I8lgcEVBD_jrwhFQzUpAdk/edit?tab=t.0#heading=h.7w3ojn5sv251',
			},
			windows: {
				hiddify:
					'https://docs.google.com/document/d/12Ye9BFYohyKISyPDa1VWYVHIVWq5ko5FSkrt_kNFp84/edit?tab=t.0',
			},
			linux: {
				hiddify:
					'https://docs.google.com/document/d/1lMjal659Uz2_ZOILEpuUSEyc7vNa8u2u0iiCRwqA52Y/edit?tab=t.0',
			},
		},
		// Док «Смена региона Apple ID на Казахстан (iOS)»
		regionChangeInstructionsDocUrl:
			'https://docs.google.com/document/d/1nME0ITjg3rcU6vDlBVGm2UecDYZNmRcZZ8JHv0WaoTE/edit?tab=t.0',
	},
	metadata: {
		title: 'SKUF.VPN | VPN для безопасного доступа в Интернет',
		description:
			'SkufVPN — ваш надежный спутник в онлайн-мире. Обеспечьте безопасность и конфиденциальность своих данных с помощью нашего высокоскоростного VPN-сервиса. Идеально подходит для защиты личной информации, обхода гео-ограничений и безопасного серфинга. Присоединяйтесь к SkufVPN и наслаждайтесь свободным интернетом без границ!',
		keywords:
			'VPN, SkufVPN, безопасность в интернете, конфиденциальность данных, прокси-сервер, обход блокировок, skufvpn instagram, skufvpn telegram, skufvpn, скуф впн, скуфвпн, впн, vpn, скуф, скуфвпн, vpn, впн, скуфvpn, скуфвпн впн',
		siteName: 'SKUF.VPN',
	},
	features: {
		seoFaq: false,
		metrika: true,
		productionSourceMaps: true,
	},
	copy: {
		heroTitleAccent: 'VPN',
		heroTitleRest: 'для безопасного интернета',
		heroSubtitle:
			'Наслаждайтесь безопасным интернетом и оставайтесь анонимным в сети – всего от 1 рубля!',
		featuresTitle: 'Почему наш VPN - это лучший выбор',
		featuresSubtitle:
			'Он обеспечивает максимальную скорость, надежную защиту данных и простоту использования для всех устройств.',
		featureCardSecurity: 'Безопасность ваших данных - шифрование на высшем уровне',
		footerTagline:
			'Безопасный и быстрый доступ к вашим любимым сайтам и сервисам. Мы обеспечиваем надежную защиту ваших данных и высокую скорость соединения.',
		fastRegisterDesc: 'Введите email для получения доступа к VPN',
		sidebarConfigLabel: 'Настройки VPN',
		configPageTitle: 'Настройки VPN',
		configBlockWarning:
			'В настоящее время встречаются блокировки VPN. Если подключение перестало работать, переключитесь на другой сервер — ваша ссылка-подписка уже включает все доступные локации и протоколы, пересоздавать ключ не нужно. Иногда VPN стабильно подключается с 3–5 попытки — это нормально.',
		autopayAccessClosed: 'Доступ к VPN серверам будет закрыт',
		reviewText1:
			'Отличный VPN сервис! Скорость интернета практически не падает, а поддержка работает круглосуточно. Очень доволен!',
		reviewText4:
			'Самый удобный VPN из всех, что я пробовала. Простой интерфейс и быстрое подключение.',
		consoleLabel: 'VPN Frontend',
	},
}

export default skufvpn
